export default __webpack_public_path__ + "static/idss-logo-ddb5f30e2cb9dac508ba85fc7d4b4d3d.svg";